import type { RJSFSchema } from "@rjsf/utils";
import { customizeValidator } from "@rjsf/validator-ajv8";
import Ajv2020 from "ajv/dist/2020";
import { localizeJsonSchemaErrors } from "src/components/common/forms/jsonSchema/jsonSchemaObjectLocalization.ts";
import type { JsonObject } from "src/components/common/forms/jsonSchema/jsonSchemaObjectInputUtils.ts";

export const jsonSchemaObjectValidator = customizeValidator<JsonObject, RJSFSchema>(
	{ AjvClass: Ajv2020 },
	localizeJsonSchemaErrors,
);
